/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotallyEasyToHandleByCompany from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotallyEasyToHandleByCompany'
import boardReportsService from 'src/services/boardReportsService'
import segmentacionService from 'src/services/segmentacionService'

const MarkertShareEasyToDriverCompany = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalEasyToDriver, setTotalEasyToDriver] = useState([])
  const [totalbySegmnet, setTotalbySegment] = useState([])
  const [gTotalEasyToDriverA, setGTotalEasyToDriverA] = useState([])
  const [gTotalEasyToDriverB, setGTotalEasyToDriverB] = useState([])
  const [zonesByTerritory, setZonesByTerritory] = useState([])
  const [moped, setMoped] = useState([])
  const [mopedSegment, setMopedSegmet] = useState([])
  const [mopedZones, setMopedZones] = useState([])
  const [gmopedZonesA, setMopedZonesA] = useState([])
  const [gmopedZonesB, setMopedZonesB] = useState([])
  const [scooter, setScooters] = useState([])
  const [scooterSegment, setScooterSegment] = useState([])
  const [scooterZones, setScooterZones] = useState([])
  const [gScooterA, setgScooterA] = useState([])
  const [gScooterB, setgScooterB] = useState([])
  const [gAScooterSubSegments, setGAscooterSubSegments] = useState([])
  const [gBScooterSubSegments, setGBscooterSubSegments] = useState([])
  const [gAMOPEDSubSegments, setGAMOPEDSubSegments] = useState([])
  const [gBMOPEDSubSegments, setGBMOPEDSubSegments] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadTotalEasyToDriver = async () => {
    const [
      totalEasyToDriver,
      totalbySegmnet,
      gTotalEasyToDriverA,
      gTotalEasyToDriverB,
      zonesByTerritory,
      moped,
      mopedSegment,
      mopedZones,
      gmopedZonesA,
      gmopedZonesB,
    ] = await Promise.all([
      boardReportsService.getTotalMarketShare('3', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO'),
      boardReportsService.getTotalMarketShare('4', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO'),
      boardReportsService.getTotalMarketShareGraphics('4a', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO'),
      boardReportsService.getTotalMarketShareGraphics('4b', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO'),
      boardReportsService.getTotalMarketShare('5', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO'),
      boardReportsService.getTotalMarketShare('6', selectedDate.getFullYear(), 'subcategoria=SEMI-AUTO&segmento=MOPED'),
      boardReportsService.getTotalMarketShare(
        '11',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=MOPED'
      ),
      boardReportsService.getTotalMarketShare(
        '12',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=MOPED'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5a',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=MOPED'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5b',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=MOPED'
      ),
    ])
    setTotalEasyToDriver(totalEasyToDriver)
    setTotalbySegment(totalbySegmnet)
    setGTotalEasyToDriverA(gTotalEasyToDriverA)
    setGTotalEasyToDriverB(gTotalEasyToDriverB)
    setZonesByTerritory(zonesByTerritory)
    setMoped(moped)
    setMopedSegmet(mopedSegment)
    setMopedZones(mopedZones)
    setMopedZonesA(gmopedZonesA)
    setMopedZonesB(gmopedZonesB)
  }

  const reloadTotalEasyToDriverSooters = async () => {
    const [scooter, scooterSegment, scooterZones, gScooterA, gScooterB] = await Promise.all([
      boardReportsService.getTotalMarketShare(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=SCOOTER'
      ),
      boardReportsService.getTotalMarketShare(
        '11',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=SCOOTER'
      ),
      boardReportsService.getTotalMarketShare(
        '12',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=SCOOTER'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5a',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=SCOOTER'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5b',
        selectedDate.getFullYear(),
        'subcategoria=SEMI-AUTO&segmento=SCOOTER'
      ),
    ])
    setScooters(scooter)
    setScooterSegment(scooterSegment)
    setScooterZones(scooterZones)
    setgScooterA(gScooterA)
    setgScooterB(gScooterB)
  }

  const getScooterG = async () => {
    const response = await segmentacionService.getSubSegmentos('5')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6a',
            selectedDate.getFullYear(),
            `subcategoria=SEMI-AUTO&segmento=SCOOTER&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGAscooterSubSegments([arr, response])
    })
  }

  const getScooterGB = async () => {
    const response = await segmentacionService.getSubSegmentos('5')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6b',
            selectedDate.getFullYear(),
            `subcategoria=SEMI-AUTO&segmento=SCOOTER&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGBscooterSubSegments([arr, response])
    })
  }

  const getMopedGA = async () => {
    const response = await segmentacionService.getSubSegmentos('4')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6a',
            selectedDate.getFullYear(),
            `subcategoria=SEMI-AUTO&segmento=MOPED&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGAMOPEDSubSegments([arr, response])
    })
  }

  const getMopedGB = async () => {
    const response = await segmentacionService.getSubSegmentos('4')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6b',
            selectedDate.getFullYear(),
            `subcategoria=SEMI-AUTO&segmento=MOPED&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGBMOPEDSubSegments([arr, response])
    })
  }

  useEffect(() => {
    getMopedGA()
    getMopedGB()
    getScooterG()
    getScooterGB()
    reloadTotalEasyToDriver()
    reloadTotalEasyToDriverSooters()
  }, [selectedDate])

  return (
    <TotallyEasyToHandleByCompany
      moped={moped}
      scooter={scooter}
      gScooterA={gScooterA}
      gScooterB={gScooterB}
      gAMOPEDSubSegments={gAMOPEDSubSegments}
      gBMOPEDSubSegments={gBMOPEDSubSegments}
      scooterSegment={scooterSegment}
      mopedSegment={mopedSegment}
      mopedZones={mopedZones}
      scooterZones={scooterZones}
      gmopedZonesA={gmopedZonesA}
      gmopedZonesB={gmopedZonesB}
      zonesByTerritory={zonesByTerritory}
      totalEasyToDriver={totalEasyToDriver}
      totalbySegmnet={totalbySegmnet}
      gAScooterSubSegments={gAScooterSubSegments}
      gBScooterSubSegments={gBScooterSubSegments}
      gTotalEasyToDriverA={gTotalEasyToDriverA}
      gTotalEasyToDriverB={gTotalEasyToDriverB}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default MarkertShareEasyToDriverCompany
